import { Ionicons } from '@expo/vector-icons';
import { Stack } from 'expo-router';
import React from 'react';
import { Platform, Pressable, StatusBar, View } from 'react-native';

import { RefreshButton } from '@/components/common/refresh-button';
import MobileDashboard from '@/components/dashboards/mobile';
import { V2Dashboard } from '@/components/dashboards/v2';
import { HomeHeaderButton } from '@/components/layout/home-header-button';
import { useGlobalSearch } from '@/hooks/use-global-search';
import { useIsLargeScreen } from '@/hooks/use-is-large-screen';
import { useIsNativePhone } from '@/hooks/use-is-native-phone';
import { useWorkOrdersRefresh } from '@/hooks/use-work-orders-refresh';

const HomeScreen: React.FC = () => {
	const isLargeScreen = useIsLargeScreen();
	const { openSearch } = useGlobalSearch();
	const onRefresh = useWorkOrdersRefresh();
	/**
	 * The iPhone app gets no dashboard, whatever the role (#684): Home IS the work-order list,
	 * the same `MobileDashboard` the phone's /work-orders shows, and the drawer's Work Orders row
	 * lands on it. Rendered here rather than redirected, so Home stays the root of the back stack.
	 * The iPad and web keep the dashboard.
	 */
	const workOrderListHome = useIsNativePhone();

	return (
		<>
			<Stack.Screen options={{
				title: workOrderListHome ? 'Work Orders' : 'Home',
				headerShown: !isLargeScreen,
				headerLeft: !isLargeScreen ? () => <HomeHeaderButton /> : undefined,
				headerRight: !isLargeScreen ? () => (
					<View style={{ flexDirection: 'row', alignItems: 'center' }}>
						{Platform.OS === 'web' && <RefreshButton onRefresh={onRefresh} />}
						<Pressable onPress={openSearch} style={{ padding: 8 }}>
							<Ionicons name="search-outline" size={24} color="#333" />
						</Pressable>
					</View>
				) : undefined,
			}} />
			<StatusBar barStyle="dark-content" />
			{workOrderListHome ? <MobileDashboard /> : <V2Dashboard />}
		</>
	);
};

export default HomeScreen;
